import { useNavigate } from 'react-router-dom'

import overview from 'assets/images/overview.svg'
import { description } from 'static/text.json'

const Landing = props => {
  const navigate = useNavigate()
  return (
    <div className='page'>
      <div className='hero'>
        <div className='hero-content'>
          <h1>Know your company.<br /><i>All of it.</i></h1>
          <p>{ description }</p>
          <button className='hero-btn' onClick={() => navigate('/signup')}>
            Join for FREE
          </button>
        </div>
        <div className='hero-img'>
          <img src={overview} />
        </div>
      </div>
    </div>
  )
}

export default Landing
